export const EditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
      <path
        className="group-hover:fill-tdpldark"
        d="M0.5 11.875V15H3.625L12.8417 5.78334L9.71667 2.65834L0.5 11.875ZM15.2583 3.36667C15.5833 3.04167 15.5833 2.51667 15.2583 2.19167L13.3083 0.241675C12.9833 -0.0833252 12.4583 -0.0833252 12.1333 0.241675L10.6083 1.76667L13.7333 4.89167L15.2583 3.36667Z"
        fill="#355968"
      />
    </svg>
  )
}
